import styled from "styled-components";

export const Panel = styled.div`
  width: 100%;
  margin-top: 8px;
  padding: 17px 30px 24px;
  box-sizing: border-box;
  border-radius: 14px;
  border: 0.707px solid #d9d9d9;
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
`;

export const PanelTitle = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 23px;
  font-weight: 700;
`;

export const Divider = styled.div`
  margin: 12px 0;
  width: 100%;
  height: 1.5px;
  background: #d9d9d9;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;

  .time {
    width: 16%;
  }
  .nickname {
    width: 18%;
  }
  .ticket {
    width: 28%;
  }
  .count {
    width: 12%;
  }
  .action {
    width: 26%;
  }
`;

export const Head = styled.div`
  display: flex;
  width: 100%;
  padding: 5px 20px;
  box-sizing: border-box;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 280px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 56px;
  padding: 8px 20px;
  box-sizing: border-box;
  border-radius: 14px;
  background: #ecf0f3;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    color: #121212;
    text-align: center;
    word-break: keep-all;
  }

  > .item.ticket {
    font-weight: 700;
  }

  > .item.count {
    color: #7f25fb;
    font-weight: 700;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`;

export const AcceptButton = styled.button`
  min-width: 72px;
  height: 32px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  background: #7f25fb;
  color: #fff;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    background: #c9c9c9;
    cursor: default;
  }
`;

export const RejectButton = styled.button`
  min-width: 72px;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  background: #fff;
  color: #d14343;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    color: #b7b7b7;
    cursor: default;
  }
`;

export const Empty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 220px;
  color: #969696;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
`;
